import {
  stepClasses,
  stepConnectorClasses,
  stepIconClasses,
  stepLabelClasses,
  svgIconClasses,
  typographyClasses,
} from '@mui/material';
import Stepper from '@mui/material/Stepper';
import {
  alpha,
  styled,
} from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  backgroundColor: theme.palette.info.main,
  borderRadius: 8,
  minHeight: 50,
  padding: '0 60px',
  justifyContent: 'center',
  [theme.breakpoints.down('lg')]: {
    padding: '0 16px',
  },
  [`& .${stepConnectorClasses.root}`]: {
    flex: 'initial',
    width: 20,
    margin: '0 16px',
    [theme.breakpoints.down('lg')]: {
      width: 12,
      margin: '0 8px',
    },
  },
  [`& .${stepConnectorClasses.root}.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.success.main,
    },
  },
  [`& .${stepConnectorClasses.root} .${stepConnectorClasses.line}`]: {
    borderColor: alpha(theme.palette.primary.main, 0.25),
  },
  [`& .${stepClasses.root}.${stepClasses.completed}`]: {
    [`& .${stepLabelClasses.label}`]: {
      color: theme.palette.text.secondary,
      fontWeight: 600,
    },
    [`& .${stepLabelClasses.label} + .${typographyClasses.root}`]: {
      color: theme.palette.text.secondary,
    },
    [`& + .${stepConnectorClasses.root} .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.success.main,
    },
  },
  [`& .${stepLabelClasses.iconContainer}`]: {
    paddingRight: 16,
    [theme.breakpoints.down('lg')]: {
      paddingRight: 0,
    },
  },
  [`& .${stepLabelClasses.label}`]: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    fontFamily: theme.typography.body1.fontFamily,
    [`&.${stepLabelClasses.active}`]: {
      color: theme.palette.text.secondary,
      fontWeight: 600,
    },
    [`&.${stepLabelClasses.disabled}`]: {
      color: theme.palette.text.disabled,
    },
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
  [`& .${stepLabelClasses.active}`]: {
    color: theme.palette.common.white,
    [`& + .${typographyClasses.root}`]: {
      color: theme.palette.text.secondary,
    },
    [`& .${svgIconClasses.root}`]: {
      color: theme.palette.common.white,
    },
    [`& .${stepIconClasses.text}`]: {
      color: theme.palette.primary.main,
      fill: theme.palette.primary.main,
    },
  },
  [`& .${stepClasses.root}.${stepClasses.completed}`]: {
    [`& .${stepLabelClasses.label}`]: {
      color: theme.palette.text.secondary,
    },
    [`& .${stepLabelClasses.label} + .${typographyClasses.root}`]: {
      color: theme.palette.text.secondary,
    },
    [`& + .${stepConnectorClasses.root} .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.success.main,
    },
    [`& .${svgIconClasses.root}`]: {
      color: theme.palette.success.main,
    },
  },
  [`& .${svgIconClasses.root}`]: {
    fontSize: 24,
    color: alpha(theme.palette.common.white, 0.25),
  },
  [`& .${stepIconClasses.text}`]: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    color: alpha(theme.palette.primary.main, 0.2),
    fill: alpha(theme.palette.primary.main, 0.2),
    fontFamily: theme.typography.body1.fontFamily,
  },
}));

export const StyledSecondaryStepper = styled(Stepper)(({ theme }) => ({
  height: 123,
  [theme.breakpoints.down('sm')]: {
    height: 80,
  },
  backgroundColor: theme.palette.primary.main,
  [`& .${stepConnectorClasses.root}.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.light,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.primary.light,
  },
  [`& .${stepLabelClasses.active}`]: {
    color: theme.palette.common.white,
    [`& + .${typographyClasses.root}`]: {
      color: theme.palette.common.white,
    },
    [`& .${svgIconClasses.root}`]: {
      color: theme.palette.common.white,
    },
  },
  [`& .${stepLabelClasses.completed}`]: {
    [`.${svgIconClasses.root}`]: {
      color: theme.palette.common.white,
    },
  },
  [`& .${stepClasses.root}`]: {
    paddingRight: 16,
    paddingLeft: 16,
    [theme.breakpoints.down(1200)]: {
      paddingRight: 10,
      paddingLeft: 10,
    },
  },
  [`& .${stepClasses.root}.${stepClasses.completed}`]: {
    [`& .${stepLabelClasses.label}`]: {
      color: theme.palette.common.white,
    },
    [`& .${stepLabelClasses.label} + .${typographyClasses.root}`]: {
      color: theme.palette.common.white,
    },
    [`& + .${stepConnectorClasses.root} .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.common.white,
    },
  },
  [`& .${stepLabelClasses.iconContainer}`]: {
    paddingRight: 14,
  },
  [`& .${svgIconClasses.root}`]: {
    fontSize: 24,
    color: theme.palette.primary.light,
  },
  [`& .${stepLabelClasses.label}`]: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    fontFamily: theme.typography.body1.fontFamily,
    [`&.${stepLabelClasses.active}`]: {
      color: theme.palette.common.white,
    },
    [`&.${stepLabelClasses.disabled}`]: {
      color: theme.palette.primary.light,
    },
  },
  [`& .${stepIconClasses.text}`]: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '16px',
    color: theme.palette.primary.main,
    fill: theme.palette.primary.main,
    fontFamily: theme.typography.body1.fontFamily,
  },
  [theme.breakpoints.down(1200)]: {
    width: '100%!important',
  },
}));

export const StyledSubLabel = styled(Typography)(({ theme }) => ({
  fontSize: 10,
  fontWeight: 300,
  lineHeight: '16px',
  color: theme.palette.primary.light,
  fontFamily: theme.typography.body2.fontFamily,
  position: 'absolute',
  paddingTop: 3,
}));
